module.exports = __webpack_public_path__ + "static/media/casual_shirt.fc60e892.svg";